import React from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";

const SERVICES = [
  {
    value: "full",
    label: "Full Service Package",
    desc: "Complete interior and exterior detail — our signature service. Includes deep cleaning, full interior refresh, and paint-safe exterior wash.",
    price: "from $140",
  },
  {
    value: "interior",
    label: "Interior Reset",
    desc: "High quality cinematic interior refresh. Every surface cleaned, conditioned, and restored.",
    price: "from $90",
  },
  {
    value: "exterior",
    label: "Exterior Car Wash",
    desc: "Quick and thorough exterior wash with hand-dry finish. Wheels, tires, and glass included.",
    price: "from $70",
  },
];

export default function ServiceStep({ value, onChange, onNext, onBack }) {
  const [selected, setSelected] = React.useState(value || "");

  const submit = () => {
    if (!selected) return;
    onChange(selected);
    onNext(selected);
  };

  return (
    <div data-testid="step-service">
      <p className="overline mb-6">Step 04 · Service</p>
      <h2 className="font-serif text-4xl sm:text-5xl tracking-tighter leading-[0.95] mb-4">
        What would you
        <br />
        <span className="gold-gradient-text italic">like done?</span>
      </h2>
      <p className="text-white/55 mb-10">
        Pick the service that fits your needs. Prices adjust based on your vehicle and condition.
      </p>

      <div className="space-y-3">
        {SERVICES.map((s) => (
          <button
            key={s.value}
            onClick={() => setSelected(s.value)}
            className={`block w-full text-left p-6 border transition-all ${
              selected === s.value
                ? "border-gold bg-gold/5"
                : "border-white/10 hover:border-white/30 bg-ink-paper"
            }`}
            data-testid={`service-${s.value}`}
          >
            <div className="flex items-baseline justify-between mb-2">
              <span
                className={`font-serif text-2xl ${
                  selected === s.value ? "text-gold" : "text-white"
                }`}
              >
                {s.label}
              </span>
              <span
                className={`text-[10px] uppercase tracking-[0.3em] ${
                  selected === s.value ? "text-gold" : "text-white/30"
                }`}
              >
                {s.price}
              </span>
            </div>
            <p className="text-sm text-white/55">{s.desc}</p>
          </button>
        ))}
      </div>

      <p className="text-xs text-white/40 mt-6 text-center" style={{ maxWidth: 420, marginLeft: "auto", marginRight: "auto" }}>
        All exterior services include a free ceramic coating upgrade with a 5-star Yelp review!
      </p>

      <div className="mt-12 flex justify-between">
        <button className="btn-secondary" onClick={onBack} data-testid="service-back-button">
          <ArrowLeft size={14} /> Back
        </button>
        <button className="btn-primary" onClick={submit} disabled={!selected} data-testid="service-next-button">
          Get Estimate <ArrowRight size={14} />
        </button>
      </div>
    </div>
  );
}
